import { connect } from "react-redux";
import SurveyStepModeles from "./SurveyStepModeles";
import {
	loadSurveyProgress,
	storeSurveyProgress,
	surveySetCurrentModel,
	getLocation,
	reset,
	addStepSurvey,
} from "./../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	return {
		//currentSurvey: surveySelector(state, ownProps),
		surveyProgress: state.survey.surveyManager.surveyProgress,
		//modeleList: state.survey.surveyManager.modeleList,
		assortmentClient: state.survey.surveyManager.assortmentClient,
		currentClient: state.currentClient || {},
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		loadSurveyProgress: data => {
			dispatch(loadSurveyProgress(data));
		},
		addStepSurvey: survey => {
			dispatch(addStepSurvey(survey));
		},
		getLocation: (idClient, idRetailer) => {
			dispatch(getLocation(idClient, idRetailer));
		},
		storeSurveyProgress: () => {
			dispatch(storeSurveyProgress());
		},
		resetSimulation: () => {
			dispatch(reset());
		},
		surveySetCurrentModel: currentModel => {
			dispatch(surveySetCurrentModel(currentModel));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(SurveyStepModeles);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepModeles/SurveyStepModelesContainer.js